import _ from 'lodash';
import React, {useContext} from 'react';

import {usePreferences} from '../../../ducks/PreferencesContext';

const TabContext = React.createContext({
    activeTab: null,
    setActiveTab: () => {},
});

/**
 * @param {object} param0
 * @param {string} param0.id
 * @param {string} param0.defaultTab
 * @param {import('react').ReactNode} param0.children
 * @returns {import('react').ReactElement}
 */
const StickyTab = ({id, defaultTab, children}) => {
    const {preferences, setPreference} = usePreferences();
    const preferenceName = id === 'default' ? 'activeTab' : `activeTab-${id}`;
    const activeTab = _.get(preferences, preferenceName, defaultTab);
    const setActiveTab = (tabId) => {
        setPreference(preferenceName, tabId);
    };

    return <TabContext.Provider value={{activeTab, setActiveTab}}>{children}</TabContext.Provider>;
};

/**
 * @param {object} param0
 * @param {string} param0.id
 * @param {import('react').ReactNode} param0.children
 * @returns {import('react').ReactElement}
 */
const StickyTabContent = ({id, children}) => {
    const {activeTab} = useContext(TabContext);
    if (id != activeTab) return null;

    return children;
};

export {StickyTab, StickyTabContent, TabContext};
